import { useCallback, useEffect, useRef } from 'react';
import { beginUserRefreshBlock } from '../utils/userQueryLock';

const useUserRefreshLock = () => {
  const releaseUserRefreshBlockRef = useRef(null);

  const unlockUserRefresh = useCallback(() => {
    if (releaseUserRefreshBlockRef.current) {
      releaseUserRefreshBlockRef.current();
      releaseUserRefreshBlockRef.current = null;
    }
  }, []);

  const lockUserRefresh = useCallback(() => {
    unlockUserRefresh();
    releaseUserRefreshBlockRef.current = beginUserRefreshBlock();
  }, [unlockUserRefresh]);

  useEffect(() => () => unlockUserRefresh(), [unlockUserRefresh]);

  return {
    lockUserRefresh,
    unlockUserRefresh
  };
};

export default useUserRefreshLock;
